import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { api } from '../lib/api';

export function OAuthCallbackPage() {
  const nav = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void (async () => {
      try {
        // PKCE flow: ?code= query param
        const code = new URLSearchParams(window.location.search).get('code');
        if (code) {
          await api.post('/auth/callback', { code });
          nav('/orders', { replace: true });
          return;
        }

        // Implicit flow: #access_token= hash fragment
        const hash = new URLSearchParams(window.location.hash.slice(1));
        const accessToken = hash.get('access_token');
        const refreshToken = hash.get('refresh_token');
        if (accessToken && refreshToken) {
          await api.post('/auth/token', { accessToken, refreshToken });
          nav('/orders', { replace: true });
          return;
        }

        setError('로그인 정보를 찾을 수 없습니다. 다시 로그인해 주세요.');
      } catch (e) {
        const m = e as { message?: string };
        setError(m.message ?? '로그인 처리에 실패했습니다. 다시 시도해 주세요.');
      }
    })();
  }, [nav]);

  return (
    <div className="flex min-h-screen items-center justify-center text-ink-700">
      {error ? (
        <div className="max-w-sm rounded border border-red-200 bg-red-50 p-4 text-sm text-red-800">
          {error}
        </div>
      ) : (
        <div className="text-sm">로그인 처리 중…</div>
      )}
    </div>
  );
}
